/**
 * Monetization analytics — uses shared trackEvent (standard params + page_path).
 */

import { getAnalyticsPagePath, trackEvent } from '@/lib/analytics'

export type AnalyticsEvent =
  | 'upgrade_prompt_shown'
  | 'upgrade_clicked'
  | 'upgrade_completed'
  | 'subscription_check_failed'
  | 'usage_limit_reached'

export interface AnalyticsEventData {
  event: AnalyticsEvent
  feature?: string
  userId?: string
  tier?: 'free' | 'pack_leader'
  currentUsage?: number
  limit?: number
  source?: string
  reason?: string
  [key: string]: any
}

export function trackAnalytics(data: AnalyticsEventData): void {
  const label =
    data.feature ||
    data.event ||
    'monetization'

  trackEvent(data.event, {
    page_path: getAnalyticsPagePath(),
    event_category: 'monetization',
    event_label: label,
    feature: data.feature,
    user_id_analytics: data.userId,
    tier: data.tier,
    current_usage: data.currentUsage,
    limit: data.limit,
    source: data.source,
    reason: data.reason,
    value: data.currentUsage,
  })

  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
    console.log('[Analytics]', data)
  }
}

export function trackUpgradePromptShown(feature: string, userId?: string): void {
  trackAnalytics({
    event: 'upgrade_prompt_shown',
    feature,
    userId,
  })
}

export function trackUpgradeClicked(
  feature: string,
  userId?: string,
  source?: string
): void {
  trackAnalytics({
    event: 'upgrade_clicked',
    feature,
    userId,
    source,
  })
}

export function trackUpgradeCompleted(userId: string, feature?: string): void {
  trackAnalytics({
    event: 'upgrade_completed',
    feature,
    userId,
  })
}

export function trackSubscriptionCheckFailed(
  feature: string,
  reason: 'subscription_required' | 'usage_limit_exceeded',
  userId?: string,
  tier?: 'free' | 'pack_leader',
  currentUsage?: number,
  limit?: number
): void {
  trackAnalytics({
    event: 'subscription_check_failed',
    feature,
    reason,
    userId,
    tier,
    currentUsage,
    limit,
  })
}
